import * as ionIcons from 'ionicons/icons'
import { addIcons } from 'ionicons'
import { Injectable } from '@angular/core';

export type IonIconsName = keyof typeof ionIcons;

@Injectable({
    providedIn: "root",
})
export class IonIconsService {
    private _usedIonIcons: IonIconsName[] = [
        'add',
        'addCircle',
        'arrowBack',
        'arrowDownCircle',
        'arrowForward',
        'arrowUpCircle',
        'calendarOutline',
        'caretDown',
        'caretDownOutline',
        'checkmarkCircle',
        'checkmarkSharp',
        'checkmarkOutline',
        'chevronBack',
        'chevronBackOutline',
        'chevronDownOutline',
        'chevronForward',
        'chevronForwardOutline',
        'clipboardOutline',
        'close',
        'closeCircle',
        'closeCircleSharp',
        'closeOutline',
        'closeSharp',
        'create',
        'createOutline',
        'downloadOutline',
        'eye',
        'informationCircleOutline',
        'lockClosed',
        'logoApple',
        'logoGoogle',
        'menu',
        'menuOutline',
        'menuSharp',
        'nuclear',
        'paperPlaneSharp',
        'pause',
        'pencil',
        'people',
        'play',
        'playSharp',
        'powerOutline',
        'refreshCircle',
        'refreshOutline',
        'remove',
        'removeCircle',
        'sad',
        'sadOutline',
        'searchOutline',
        'search',
        'searchSharp',
        'sendSharp',
        'share',
        'star',
        'starOutline',
        'starSharp',
        'swapHorizontalOutline',
        'timeOutline',
        'todayOutline',
        'trash',
        'trashOutline',
        'warningOutline',
    ];

    constructor() { }

    initIonIcons() {
        const usedIonIconObject: Record<IonIconsName, string> = this._usedIonIcons.reduce((accumulator, iconName) => {
            accumulator[iconName] = ionIcons[iconName];
            return accumulator;
        }, {} as Record<IonIconsName, string>);

        addIcons(usedIonIconObject);
    }
}
